import classNames from "classnames";
import React from "react";

export default function Button({
  onClick,
  type,
  disabled,
  topClassName,
  className,
  style,
  ...rest
}) {
  return (
    <div className={classNames(topClassName, "button")}>
      <button
        type={type}
        disabled={disabled}
        className={classNames(
          className,
          "text-sm cursor-pointer rounded-lg border border-stroke px-4 py-[9px] flex place-items-center text-black-2 transition hover:bg-opacity-90",
          {
            "opacity-50 cursor-not-allowed bg-gray-600 border-gray-400 text-gray-600 hover:bg-gray-600": disabled,
          }
        )}
        style={style}
        onClick={onClick}
        {...rest}
      >
      </button>
    </div>
  );
}
